/**
 * `setTimeout` for an async task that handles its own failures, such as the drafts' debounced
 * saves, whose bodies catch everything they can throw.
 *
 * setTimeout drops the promise an async callback returns, so a rejection there is unhandled.
 * Naming the helper is the claim that there is none to handle; a task that can reject belongs
 * in a try/catch first.
 */
export const runLater = (task: () => Promise<unknown>, delay: number): ReturnType<typeof setTimeout> =>
  setTimeout(() => { void task(); }, delay);
